module.exports = __webpack_public_path__ + "img/MEDIA055.414d7a21.jpg";